import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Hyrox from './pages/Hyrox';
import Cours from './pages/Cours';
import ClubPage from './pages/ClubPage';
import Equipe from './pages/Equipe';
import Tarifs from './pages/Tarifs';
import Contact from './pages/Contact';
import Reserver from './pages/Reserver';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/lhyrox" element={<Hyrox />} />
          <Route path="/nos-cours" element={<Cours />} />
          <Route path="/club/:slug" element={<ClubPage />} />
          <Route path="/equipe" element={<Equipe />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reserver" element={<Reserver />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
